<template>

  <div>

    <b-modal size="lg" v-model="modalTypeComment" @hide="getTypeComment" id="modal-type-comment" hide-footer
             title="Tipos de Comentário">
      <TypeCommentDialog v-if="modalTypeComment" :foreign-key="this.foreignKey"/>
    </b-modal>

    <t-button @click="openComment(0)" class="ml-3">
      <b-icon-pencil-square class="mr-1" style="scale: 0.9"/>
      Novo comentário
    </t-button>


    <b-row class="p-3 pt-0 pb-0" v-if="filtered || items.totalElements > 0">

      <t-input-search
          cols="3"
          v-model="search.default" label="Comentário"/>

      <t-input-search cols="3" v-if="!disabledCategory" v-model="search.typeCommentId" label="Categoria" select-colors
                      :options="typeCommentOptions"/>

      <t-input-search
          v-if="!disabledKeyword"
          @keyup.enter.prevent="searchComments" @keydown.enter.prevent="searchComments"
          cols="3" v-model="search.keyword" label="Keyword"/>

      <t-button @click="searchComments" outline-primary form-inline>
        <b-icon-search class="mr-1" style="scale: 0.8"></b-icon-search>
        Filtrar
      </t-button>

    </b-row>

    <t-msg class="mt-3" v-if="!filtered && listIsLoaded && items.totalElements === 0" warning>Nenhum comentário
      inserido!
    </t-msg>

    <t-msg class="mt-3" v-if="filtered && listIsLoaded && items.totalElements === 0" warning>Nenhum comentário
      encontrado de acordo com os parâmetros informados na busca!
    </t-msg>

    <b-modal id="modal-comment-view" size="xl" scrollable hide-footer v-if="modalCommentTitle!== ''"
             :title="modalCommentTitle">

      <div v-html="htmlForEditor" class="modalCommentContent p-2"
           :class="{'comment-type-public-list':form.sharingFileType === SharingFileType.type.PUBLIC}"

           style="border-bottom: solid 1px #ccc"></div>

      <b-row class="mt-2">


        <b-col cols="12">


          <t-input v-if="enableSharing" v-model="form.sharingFileType" label="Acesso" :options="SharingFileType.list"
                   radio fixed/>


          <b-row>

            <t-input cols="6" v-model="form.logControl.createdUser" label="Usuário" fixed/>
            <t-input cols="6" v-model="form.logControl.createdDate" label="Data Criação" fixed datetime/>

          </b-row>

          <t-input v-if="!disabledCategory" v-model="form.typeCommentId" label="Categoria" disabled select-colors
                   :options="typeCommentOptions"/>

          <t-keyword v-if="!disabledKeyword" v-model="form.keywords"/>

        </b-col>

      </b-row>


    </b-modal>


    <t-form-list
        pageable
        :items="items.content"
        :total-pages="items.totalPages"
        :total-elements="items.totalElements"
        :generalErrors="generalErrors" :fields="fields" :command="command" :user-auth="userAuth"
        :status="status"
        :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
        hide-header
        primary-key-column="commentId"
        @getPage="getList"
        @onSubmit="onSubmit"
        @onItemRead="openComment"
        @onItemDelete="onItemDeleteDefault">

      <t-blackout white opacity9 v-model="blackoutComment">

        <template #buttons-top>

          <div style="max-width: 860px; margin: auto; width: 90%">

            <b-row>

              <div class="col-12 d-flex justify-content-end align-items-end">
                <b-button class="p-0" variant="link" @click="blackoutComment = false">
                  <b-icon-x/>
                  Fechar
                </b-button>
              </div>

            </b-row>

          </div>

        </template>

        <div style="background-color: #FFFFFF">

          <slot name="modal-header"></slot>

          <t-input v-model="form.commentId" hidden/>

          <b-col cols="12" v-if="enableSharing" class="border-bottom p-1 mb-2">


            <b-radio-group id="" v-model="form.sharingFileType">

              <b-radio
                  :value="SharingFileType.type.RESTRICT">
                <div class=""><b>Comentário Restrito</b></div>
              </b-radio>

              <b-radio
                  class="text-warning"
                  :value="SharingFileType.type.PUBLIC">
                <div class="alert-warning"><b>Comentário público para todos </b>
                  <t-help :title="sharingHelp"/>
                </div>
              </b-radio>

            </b-radio-group>

          </b-col>


          <t-input v-if="!disabledTitle"
                   :class="{'comment-type-public':form.sharingFileType === SharingFileType.type.PUBLIC}" label="Título"
                   required v-model="form.title" class-input="text-input-title"/>

          <vue-editor
              ref="editorComment"
              :editorOptions="editorSettings"
              :customModules="customModulesForEditor"
              :disabled="status === 'sending'"
              :class="{'form-disabled':status === 'sending','comment-type-public':form.sharingFileType === SharingFileType.type.PUBLIC}"
              useCustomImageHandler
              @image-added="handleImageAdded"
              @focus="onEditorFocus"
              @blur="onEditorBlur"
              @selection-change="onSelectionChange"
              v-model="htmlForEditor">
          </vue-editor>


          <b-row class="mt-2" v-if="!disabledCategory || !disabledKeyword">

            <b-col cols="12" v-if="!disabledCategory">

              <t-input v-model="form.typeCommentId" label="Categoria" required select-colors
                       :options="typeCommentOptions">
                <template #input-group-append>
                  <t-button title="Adicionar Tipo de Conteúdo" @click="openDialogTypeComment"
                            icon-plus/>
                </template>
              </t-input>

              <t-keyword v-if="!disabledKeyword" v-model="form.keywords"/>

            </b-col>


          </b-row>

          <b-row>

            <div class="col-12 d-flex">

              <div class="bg-light container_blackout_footer_button">

                <t-button class="mt-2"
                          :sending="onSending"
                          primary submit :text="t(command) + ' Comentário'"/>
              </div>


            </div>

          </b-row>


        </div>

      </t-blackout>


      <template #list-content="{item}">

        <b-col cols="12">

          <div v-if="item.sharingFileType === SharingFileType.type.PUBLIC"><b-badge variant="warning" class="mb-2">Comentário Público</b-badge></div>

          <b-card-title v-if="item.title !== undefined && item.title!== ''">{{ item.title }}</b-card-title>

          <div class="p-3">
            {{ item.resume }}



          </div>



          <t-button outline-secondary small @click="readComment(item.commentId)">
            <b-icon-eye style="scale: 0.8" class="mr-1"></b-icon-eye>
            Detalhar
          </t-button>

          <div class="pt-2 d-flex justify-content-between">

            <div class="d-flex">

              <div class="mr-2" v-if="item.typeComment !== undefined && item.typeComment!== ''">
                <small class="opacity-6">
                  <i class="fa fa-circle" :style="{'color': item.color}"></i>
                  {{ item.typeComment }}
                </small>
              </div>

              <div class="mr-2" v-if="item.keywords && item.keywords !== ''">
                <small class="opacity-6">
                  <i class="fa fa-hashtag"></i>
                  {{ item.keywords }}
                </small>
              </div>

            </div>

            <div class="d-flex">

              <div class="mr-2">
                <small class="opacity-6">
                  <i class="fa fa-circle mr-1"></i>
                  <span v-if="item.logControl.updatedDate !== undefined && item.logControl.updatedDate !== null"> {{
                      item.logControl.updatedUser
                    }}</span>
                  <span v-else> {{ item.logControl.createdUser }}</span>
                </small>
              </div>

              <div class="mr-2">
                <small class="opacity-6">
                  <i class="fa fa-calendar-alt mr-1"></i>
                  <span v-if="item.logControl.updatedDate !== undefined && item.logControl.updatedDate !== null"> {{
                      item.logControl.updatedDate | datetime
                    }}</span>
                  <span v-else> {{ item.logControl.createdDate | datetime }}</span>
                </small>
              </div>

            </div>


          </div>

        </b-col>


      </template>

    </t-form-list>


  </div>


</template>
<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin";
import pageFormListMixin from "@/mixins/page/pageFormListMixin";
import TypeCommentDialog from "@/views/modules/general/TypeCommentDialog";

import {Quill, VueEditor} from "vue2-editor";
import ImageResize from 'quill-image-resize-vue';
import {ImageDrop} from "quill-image-drop-module";
import typeCommentService from "@/services/modules/general/TypeComment.service";
import ui from "@/assets/scripts/ui";
import tFormList from "@/components/template/form/list/t-form-list";
import CommentValidationType from "@/model/types/modules/general/CommentValidationType";
import TKeyword from "@/components/template/form/input/t-keyword";
import SharingFileType from "@/model/types/resource/SharingFileType";

Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  name: 'Comment',
  components: {TKeyword, VueEditor, TypeCommentDialog, tFormList},
  data() {
    return {
      SharingFileType,
      filtered: false,
      assembleParams: new URLSearchParams(), //Sobreposto para monstagem contadicional e obtenção de renderRules correto
      path: "general/comment", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "pageId", //SEMPRE UTILIZAR A pageId original da entidade sem overrides, pois isso será checado internamente.
      fields: [
        {keyRead: "commentId", keyDelete: "commentId"},
        {key: "createdDate", label: "Data Modificado", cols: "3", formatter: "datetime"},
        {key: "createdUser", label: "Responsável", cols: "3"},
        {key: "version", label: "Versão", cols: "5"},
        {key: "qtyModifications", label: "Qtd. Modificações", cols: "2", align: "right"},
      ],
      form: {
        commentId: 0,
        pageId: this.foreignKey,
        relationKey: this.relationKey,
        typeCommentId: 0,
        sharingFileType: 1, /*Padrão será sempre restrito*/

        title: "",
        resume: "",
        content: "",
        keywords: [],
        status: 1
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      validationCommentOption: 0,
      search: {
        default: "",
        typeCommentId: 0,
        keyword: "",
      },
      pageHistoryLogNumber: 1, //declara aqui para não conflitar com pageNumber externo
      searchParamsComment: new URLSearchParams(), //declara aqui para não conflitar
      modalCommentTitle: "",
      blackoutComment: false,
      commentId: 0,
      modalTypeComment: false,
      htmlForEditor: "",
      customModulesForEditor: [
        {alias: "imageDrop", module: ImageDrop},
        {alias: "imageResize", module: ImageResize}
      ],
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {modules: ['Resize', 'DisplaySize']}
        }
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
        ["image", "code-block"]
      ],
      typeCommentOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    disabledTitle: Boolean,
    disabledCategory: Boolean,
    disabledKeyword: Boolean,
    enableSharing: Boolean,
    sharingHelp: {
      type: String,
      default: 'Caso desejar disponibilizar públicamente o comentário, mude para público.',
    },
    relationKey: {
      type: Number,
      required: true,
    },
  },

  methods: {

    defaultForm() {

      //Fecha o blackoutcomment
      this.blackoutComment = false
      this.htmlForEditor = "" //Limpa editor

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      //Padrão neste caso
      this.command = 'insert'
      this.form.pageId = this.foreignKey
      this.form.relationKey = this.relationKey
      this.form.sharingFileType = 1
      this.form.keywords = []


    },

    mountedPrepare() {

      this.listParams = new URLSearchParams()
      this.listParams.append('pageId', this.foreignKey)
      this.listParams.append('relationKey', this.relationKey)

      this.assembleParams.append("pageId", this.foreignKey)

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      this.validationCommentOption = this.getRenderRule('validationCommentOption')

      //Remove o acesso de edição
      if (this.validationCommentOption === CommentValidationType.type.ONLY_VIEW)
        this.userAuth.validation.validationUpdate = false

      //Remove o acesso de exclusão
      if (this.validationCommentOption !== CommentValidationType.type.ALL)
        this.userAuth.validation.validationDelete = false


      await this.getTypeComment()

      await this.getList()

      this.pageListIsLoaded = true

    },
    async onSubmit() {

      if (this.htmlForEditor !== '') {

        this.form.content = this.htmlForEditor
        this.form.resume = this.$refs.editorComment.quill.getText().replaceAll('\n', ' ').substring(0, 1000).trim()

        await this.setSendingFormListDefault(this.form.commentId)

      } else {

        ui.msgError(this, "Preencha o comentário desejado antes de continuar!");

      }

    },

    mountedList() {

      this.listIsLoaded = true

    },


    //--------------------------------------------------------------------------------------

    searchComments() {

      this.listParams = new URLSearchParams()
      this.listParams.append('pageId', this.foreignKey)
      this.listParams.append('relationKey', this.relationKey)

      if (this.search.default !== '') {
        this.listParams.append("default", this.search.default)
      }

      if (this.search.typeCommentId > 0) {
        this.listParams.append("typeCommentId", this.search.typeCommentId)
      }

      if (this.search.keyword !== '') {
        this.listParams.append("keyword", this.search.keyword)
      }

      this.filtered = true

      this.getList(1)

    },

    readComment(id) {

      this.onItemReadDefault(id, () => {

        if (this.disabledTitle) {
          this.modalCommentTitle = "Detalhes"
        } else {
          this.modalCommentTitle = this.form.title
        }


        this.htmlForEditor = this.form.content
        this.openDialogForm('modal-comment-view')

      })

    },

    openComment(id) {

      if (id > 0) {

        this.onItemReadDefault(id, () => {

          this.htmlForEditor = this.form.content

          this.blackoutComment = true
          this.command = 'update'
          this.form.commentId = id

        })

      } else {
        this.resetFormDefault(this.form)
        this.defaultForm()
        this.blackoutComment = true
      }


    },

    async getTypeComment() {

      await typeCommentService.selectList(this.foreignKey).then((list) => {
        this.typeCommentOptions = list
      }).catch(error => this.responseError(error))

    },


    openDialogTypeComment() {
      this.modalTypeComment = true
      this.openDialogForm('modal-type-comment')
    },


    onEditorBlur() {
      //console.log("editor blur!", quill);
    },

    onEditorFocus() {
      //console.log("editor focus!", quill);
    },

    onSelectionChange() {
      //console.log("selection change!", range);
    },


    //Início de métodos personalizados desta tela
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      // An example of using FormData
      // NOTE: Your key could be different such as:
      // formData.append('file', file)


      const reader = new FileReader();

      reader.onload = e => {

        const sizeTotal = e.target.result.length

        if (sizeTotal <= 2000000) {

          if (file.type !== 'image/png' || file.type !== 'image/jpg' || file.type !== 'image/jpeg') {


            const img = new Image;

            img.onload = () => {

              Editor.insertEmbed(cursorLocation, "image", e.target.result);

              let images = this.$refs.editorComment.$el.getElementsByClassName('ql-editor').item(0).getElementsByTagName('img')

              for (let image of images) {

                if (image.getAttribute('resized') == null) {

                  if (img.width > 839) {
                    image.setAttribute('width', '839')
                  }

                  image.setAttribute('resized', 'Y')
                }

              }

            };

            img.src = e.target.result;


          } else {
            ui.msgError(this, "Tipo do arquivo somente poderá ser imagem e de no máximo 2MB")
          }

        } else {
          //console.log(sizeTotal)
          ui.msgError(this, "Tamanho máximo por imagem de 2MB")

        }

        resetUploader();
      }

      reader.readAsDataURL(file);

      //ATENÇÃO NÃO PERMITIR ENVIAR ARQUIVOS ACIMA DE 10MB
      //ATENÇÃO NÃO PERMITIR ARQUIVOS QUE NÃO SEJAM IMAGENS
      //ATENÇÃO NO BACK-END LIMITAR FOTOS EM 1MB PARA AGILIZAR DEPOIS CARREGAMENTO
      //Editor.insertEmbed(cursorLocation, "image", 'https://www.oxserver.com.br/sistema_online/images/layout/suporte-whatsapp.png');
      //resetUploader();

      /*var formData = new FormData();
      formData.append("image", file);

      Axios({
        url: "https://fakeapi.yoursite.com/images",
        method: "POST",
        data: formData
      })
          .then(result => {
            const url = result.data.url; // Get url from response
            Editor.insertEmbed(cursorLocation, "image", url);
            resetUploader();
          })
          .catch(err => {
            console.log(err);
          });*/
    },
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
<style>

.comment-type-public .ql-editor, .comment-type-public .text-input-title, .comment-type-public-list {
  background-color: #fdf1d3 !important;
}

.modalCommentContent img {
  max-width: 100% !important;
}

#form-footer-buttons {
  justify-content: center !important;
  border: 0;
}

.ql-editor {
  min-height: calc(100vh - 500px) !important;
  max-height: calc(100vh - 500px) !important;
}

.ql-editor img {
  max-width: 839px !important;
}

.text-input-title {
  font-size: 18px;
  font-weight: bold;
}

</style>

